import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { MapHelperService } from 'src/services/map-helper.service';
import { EnumBufferTypes } from '../../../../shared/helpers/enums/EnumBufferTypes';
import { TurfHelperService } from 'src/services/turf-helper.service';

@Injectable({
  providedIn: "root",
})
export class ValetParkingMapService {
  
  existValetParking: boolean = false;
  coordsValetParking: { lat: number, lng: number } = { lat: 90, lng: 90 };
  bufferCenterLat: number = 0;
  bufferCenterLng: number = 0;
  bufferRadioKm: number = 0.1;
  bufferFeature: any;
  
  constructor(
    private mapHelperService: MapHelperService,
    private turfHelperService: TurfHelperService,
    ) {
  }

  LoadMapValetParking() {
    // this.mapHelperService._map.on("load", () => {
      this.initializeValetParking();
    // });
  }

  initializeValetParking() {
    this.mapHelperService.AddSourceEmptyGeoJson("bufferActiveValetParkingSource", "Buffer de valet parking", 'annotation-valet-parking-geofence.png');
    this.mapHelperService.AddLayerBufferActive("layer-bufferActiveValetParking", "bufferActiveValetParkingSource", EnumBufferTypes.Valet_Parking, "Buffer de valet parking");

    this.mapHelperService.AddSourceEmptyGeoJson("centerPointSource", "Punto central de valet parking", 'centerPin.png');
    this.mapHelperService.addLayerCenterPoint('centerPoint-layer','centerPointSource', "Punto central de valet parking");
  }
  
  private valetParkingDragEvent = () => {
    // Obtener las coordenadas del centro del mapa y actualizar el punto central
    const center = this.mapHelperService._map.getCenter();
    var geoJsonData = {
      type: 'FeatureCollection',
      features: [
        {
          type: 'Feature',
          geometry: {
            type: 'Point',
            coordinates: [center.lng, center.lat]
          }
        }
      ]
    }
    this.mapHelperService.UpdateLayerGeoJson("centerPointSource", geoJsonData);

    // Actualizar las coordenadas del valet parking y el buffer
    this.coordsValetParking = { lat: center.lat, lng: center.lng};
    this.UpdateValetParkingBuffer();
  };
    
  CreateValetParkingDragEvent(){
    //crea el buffer inicial y el evento de drag
    this.AssignValetParkingServiceValues();
    this.mapHelperService.FlyToCameraFast(this.bufferCenterLat.toString(), this.bufferCenterLng.toString(), "20");
    this.UpdateValetParkingBuffer();
      
    // this.mapHelperService._map.on("move", this.valetParkingDragEvent);
  }
  
  UpdateValetParkingBuffer(){
    this.AssignValetParkingServiceValues();
    var buffer = this.turfHelperService.getBufferGeoJSON(this.bufferCenterLat, this.bufferCenterLng, this.bufferRadioKm);
    this.mapHelperService.UpdateLayerGeoJson("bufferActiveValetParkingSource", buffer);
    this.bufferFeature = buffer;
  }
  
  DeleteValetParkingDragEvent(){
    this.bufferRadioKm = 0.1;
    this.bufferFeature = null;

    this.mapHelperService._map.off("move", this.valetParkingDragEvent);
  }
  
  AssignValetParkingServiceValues(){
    this.bufferCenterLat = this.coordsValetParking.lat;
    this.bufferCenterLng = this.coordsValetParking.lng;
    this.bufferRadioKm = this.bufferRadioKm;
  }
  
  VerifyCarInValetParking(identifier: string){
    if(this.bufferFeature == null)
      this.bufferFeature = this.turfHelperService.getBufferGeoJSON(this.bufferCenterLat, this.bufferCenterLng, this.bufferRadioKm);

    var points = this.mapHelperService._map.getSource("locationCarActiveSource")._data;
    var turfFeaturesInsideArea = this.turfHelperService.getPointsWithinPolygon( points, this.bufferFeature );

    // busca el feature con la propiedad _Id igual al identifier
    const feature = turfFeaturesInsideArea.features.find(feature => feature.properties._Id === identifier);
  
    if (feature) {
      return true;
    }else {
      return false;
    }
  }

  ResetValetParkingActiveBuffer() {
    this.mapHelperService.UpdateLayerGeoJson("centerPointSource", this.mapHelperService.Empty_GeoJson);
    this.mapHelperService.UpdateActivePoint(this.bufferCenterLat, this.bufferCenterLng, "bufferPointActiveSource");
    this.mapHelperService.UpdateLayerGeoJson("bufferActiveValetParkingSource", this.mapHelperService.Empty_GeoJson);
  }
  
}
